/* eslint-disable import/order */
import React, { memo, useCallback, useMemo, useState } from 'react';
import { RegularTextLevel2, RegularTextLevel4 } from '@yme/tokens/typography';
import { SingleCalendar } from './SingleCalendar';
import { DEFAULT_INPUT_PLACEHOLDER_SINGLE } from './constants';
import { DatePickerMode } from './types';
// !important: md: the order affects the priority of styles
import { DatePickerCustomStyled } from './react-day-picker.custom.styled';
import { useWindowSize } from '@yme/hooks/index';
import { BottomSheet, Header } from '@yme/atoms/bottom-sheet';
import { SIZE_44, NO_ICON, CONTAINED_VARIANT, Button, TEXT_VARIANT } from '@yme/atoms/button';
import { useTranslation } from 'react-i18next';
import { Input } from './Input';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { DatePickerLibStyled } from './react-day-picker.styled';
export const DatePickerForTimeSlots = memo(({ date, inputValue, setInputValue, isRightToLeft, onDateChange, onInputBlur, inputState, bottomSheetLabel, CaptionComponent, disabledDays, }) => {
    const { isMobileView } = useWindowSize();
    const [isBottomSheetExpanded, setIsBottomSheetExpanded] = useState(false);
    const { t } = useTranslation();
    const handleDateChanged = useCallback((value) => {
        onDateChange?.(value);
        setIsBottomSheetExpanded(true);
    }, [onDateChange]);
    const toggleCalendar = useCallback(() => {
        setIsBottomSheetExpanded(true);
    }, []);
    const Calendar = useMemo(() => {
        return (React.createElement(SingleCalendar, { date: date, onChange: handleDateChanged, toggleCalendar: toggleCalendar, CaptionComponent: CaptionComponent, setInputValue: setInputValue, disabledDays: disabledDays, isRequired: true }));
    }, [CaptionComponent, date, disabledDays, handleDateChanged, setInputValue, toggleCalendar]);
    const handleCloseBottomSheet = useCallback(() => {
        setIsBottomSheetExpanded(false);
    }, []);
    const handleConfirm = useCallback(() => {
        setIsBottomSheetExpanded(false);
    }, []);
    return (React.createElement(React.Fragment, null, isMobileView ? (React.createElement(React.Fragment, null,
        React.createElement(Input, { value: inputValue, placeholder: DEFAULT_INPUT_PLACEHOLDER_SINGLE, state: inputState, datepickerMode: DatePickerMode.SINGLE, isRightToLeft: isRightToLeft, onIconClick: toggleCalendar, onTextChange: setInputValue, onDateChange: handleDateChanged, onBlur: onInputBlur }),
        React.createElement(BottomSheet, { initialFocusRef: false, open: isBottomSheetExpanded, header: React.createElement(Header, { headerLeft: React.createElement(RegularTextLevel2, { weight: 500 }, bottomSheetLabel) }), footer: React.createElement(FlexWrapper, { flexDirection: "column", gap: "10px" },
                React.createElement(Button, { size: SIZE_44, hasIconButton: NO_ICON, buttonVariant: CONTAINED_VARIANT, label: t('common_confirm_button'), onClick: handleConfirm }),
                React.createElement(Button, { size: SIZE_44, hasIconButton: NO_ICON, buttonVariant: TEXT_VARIANT, label: t('common_cancel_button'), onClick: handleCloseBottomSheet })), onDismiss: handleCloseBottomSheet },
            React.createElement(RegularTextLevel4, null,
                React.createElement(DatePickerLibStyled, null,
                    React.createElement(DatePickerCustomStyled, { mode: DatePickerMode.SINGLE, isBottomSheetNeeded: true }, Calendar)))))) : (React.createElement(RegularTextLevel4, null,
        React.createElement(DatePickerLibStyled, null,
            React.createElement(DatePickerCustomStyled, { mode: DatePickerMode.SINGLE, isLargeCalendar: true }, Calendar))))));
});
DatePickerForTimeSlots.displayName = 'DatePickerForTimeSlots';
